var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"project-endpoint",attrs:{"href":`/projects/${_vm.endpoint.project_id}/forms/${_vm.endpoint.id}`}},[_vm._v("\n  "+_vm._s(_vm.endpoint.form_name)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }